import BaseModelInstance from './base.model'
import { Milestone as ModelDefinition } from './model-definitions'

class Milestone extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }
}

export default Milestone
